import * as React from 'react';

import Collapse, { CollapseProps } from '@material-ui/core/Collapse';

export type DSCollapseProps = CollapseProps;

export const DSCollapse: React.FC<DSCollapseProps> = props => <Collapse {...props} />;
